import useAddress from './useAddress'
import BuildingPermitModal from './Fields/IT/BuildingPermit/BuildingPermitModal'
import CadastralFieldsModal from './Fields/IT/CadastralFields/CadastralFieldsModal'
import LastHolderFieldsModal from './Fields/IT/LastHolderFields/LastHolderFieldsModal'
import HouseType from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/HouseType'
import ResidenceType from './Fields/Default/ResidenceType'
import TenantType from './Fields/Default/TenantType'
import AdditionalInformation from './Fields/Default/AdditionalInformation'
import StreetNumber from './Fields/Default/StreetNumber'
import StreetName from './Fields/Default/StreetName'
import Zipcode from './Fields/Default/Zipcode'
import City from './Fields/Default/City'
import Floor from './Fields/Default/Floor'
import Staircase from './Fields/Default/Staircase'
import ApartmentNumber from './Fields/Default/ApartmentNumber'
import Province from './Fields/Default/Province'
import IsResident from './Fields/Default/IsResident'
import Consumption from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/Consumption'
import { MultipleInputsContainer, StyledTitle } from './styled-components'
import EditAddressFields from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/EditAddressFields'
import FillEnergyLandscape from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/FillEnergyLandscape'
import EnergyLandscape from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/EnergyLandscape'
import ZipcodeValidationWarning from '@/containers/SubscriptionFormPageNew/Components/MeterSaveButton/ZipcodeValidationWarning'

// Note: the per-module 'Save' button has been removed. Saving is now driven by
// the global ClientTopHeader button which dispatches CLIENT_TAB_SAVE_ALL.
const Address = ({ hidden, title }) => {
  const { LocalizedAddressSearchComponent, hasZipcodeWarning } = useAddress()

  if (hidden || !LocalizedAddressSearchComponent) {
    return null
  }

  return (
    <>
      <StyledTitle>{title}</StyledTitle>
      <ResidenceType />
      <HouseType />
      <TenantType />
      <IsResident />
      <LocalizedAddressSearchComponent />
      <EditAddressFields />
      <MultipleInputsContainer>
        <Zipcode />
        <City />
      </MultipleInputsContainer>
      <ZipcodeValidationWarning showWarning={hasZipcodeWarning} />
      <StreetNumber />
      <StreetName />
      <Province />
      <Floor />
      <Staircase />
      <ApartmentNumber />
      <AdditionalInformation />
      <Consumption />
      <FillEnergyLandscape />
      <EnergyLandscape />
      <BuildingPermitModal />
      <CadastralFieldsModal />
      <LastHolderFieldsModal />
    </>
  )
}

export default Address
